import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { WizardComponent } from '../containers/main/wizard/wizard.component';
import { TabBarComponent } from './navigation/navigation_tab_bar/tab_bar.component';
import { RouterModule } from '@angular/router';
import { ColorPickerModule } from 'ngx-color-picker';
import { SetupStepNavComponent } from './navigation/setup_step/setup_step_nav.component';
import { IntegrationStepNavComponent } from './navigation/integration_step/integration_step_nav.component';
import { LastStepNavComponent } from './navigation/last_step/last_step_nav.component';
import { ReviewsSharedModule } from '@reviews-app/reviews-shared';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    ColorPickerModule,
    ReviewsSharedModule
  ],
  exports: [
    CommonModule,
    TranslateModule,
    ColorPickerModule
  ],
  declarations: [
    WizardComponent,
    TabBarComponent,
    SetupStepNavComponent,
    IntegrationStepNavComponent,
    LastStepNavComponent
  ],
  providers: []
})
export class InstallSharedModule {

  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: InstallSharedModule
    };
  }
}
